// applicant name shown as the notification row title
export const getApplicantPreviewName = (personendaten?: { nachname?: string | null; vorname?: string | null } | null) =>
    `${personendaten?.vorname ?? ''} ${personendaten?.nachname ?? ''}`.trim();
